'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { getCookieValue } from '@/app/_shared/utils/get-cookie-value';

let initialized = false;

export function SentryClientInitializer() {
  useEffect(() => {
    if (initialized) return;
    initialized = true;

    const isEnvProd = process.env.NEXT_PUBLIC_SERVICE_ENV === 'prod';
    Sentry.init({
      dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
      tracesSampleRate: isEnvProd ? 0.01 : 0.1,
      enabled: true,
      environment: process.env.NEXT_PUBLIC_SERVICE_ENV,
      replaysOnErrorSampleRate: isEnvProd ? 0.5 : 1.0,
      replaysSessionSampleRate: isEnvProd ? 0.01 : 0.1,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.browserProfilingIntegration(),
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: true,
        }),
      ],
      beforeSend(event) {
        const isIgnore = event.request?.headers?.['User-Agent']?.includes('HeadlessChrome');
        if (isIgnore) return null;

        // 사용자 정보 추가
        const scope = Sentry.getCurrentScope();
        if (scope) {
          scope.setContext('details', {
            cgntId: getCookieValue('cgntId') || '',
            'app-device': getCookieValue('app-device') || '',
            nol_device_id: getCookieValue('nol_device_id') || '',
            nol_platform: getCookieValue('nol_platform') || '',
          });
        }

        return event;
      },
    });
  }, []);
  return null;
}
